import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "4:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-385-1-mode.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
  "4:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-385-2-modes.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
  "4:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-385-3-modes.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
  "4:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-385-4-modes.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
};

export default components;
